import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class DieScene extends MinigameScene {
    //Images
    private dieSong: Phaser.Sound.BaseSound;
    private thunder: Phaser.Sound.BaseSound;

    //values

    //logic vars

    constructor(){
        super ({
            sceneName: CONST.SCENES.DIE,
            duration: 10000,
            startScreenColor: 0x000000,
            startText: "DIE!",
            startTextColor: 0x525252,
            nextScene: CONST.SCENES.CREDITS,
            timeToStart: 6000,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 386, scale: 1.30},
                normalWithSkip: {x: 283, y: 386, scale: 1.30},
                skip: {x: 570, y: 386, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.DIE.BACKGROUND).setOrigin(0,0);

        this.dieSong = this.sound.add(CONST.AUDIO.DIESONG, {
            loop: false
        });

        this.thunder = this.sound.add(CONST.AUDIO.LIGHTNING, {
            loop: false
        });

        this.dieSong.play();
        this.thunder.play();
        this.pauseMusic(true);
    }
    
    private pauseMusic(pause: boolean){
       this.registry.get(CONST.SCENES.SOUNDTRACK).pauseMusic(pause);
    }

    _update(time: number, delta: number){
    }

    _timeout(){
        this.triggerWin();
    }

    _afterLoss(){
    }

    _afterWin(){
        this.dieSong.stop();
        this.thunder.stop();
        this.pauseMusic(false);
    }

    private triggerWin(){
        this.add.image(0, 0, CONST.DIE.END).setOrigin(0, 0).setDepth(10);
        this.winGame(12000);
    }
}
